export enum Key {
    SEARCHQUERY = "486c9a27-7be3-4ced-aada-d2b54b9eb7cd",
    SEARCHSTRING = "0a1c2493-33e3-4917-8881-92127017cf13",
    REVERSERESULT = "b3ab4007-e81d-4036-be36-82af6174f613",
    TABID = "7eaa8a1e-87fd-4012-968a-4071a0f76dfe",
    SHAREURL = "6349ca76-7027-47e3-93ac-7b5924bf0429",
    SELECTEDCHECKBOXS = "8a925428-7082-4eb4-b9e4-0859c58d68d9",
    UTAG = "1da00f4d-1941-4999-b67e-86a17c822d72",
    APPLIERFILTER = "14cf096c-1149-44c8-8e33-ca783351d6e5",
    DATAREMOVED = "5dzg22g8g-1941-9999-b3qs-86a17c822d72",
    SELECTEDDATA = "5dzg22g8g-1941-9999-b3qs-86a17c822V29",
    USINGLOCALSTOREDSTATUS = "6e34fff0-9d26-4ca2-8832-fdc461e290b4"
}